import { useEffect, useState, useRef } from 'react';
import KRGlue from '@lyracom/embedded-form-glue';
import Helper from '../../services/helper.service';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

export default function SystempayComponent({ formToken, publicKey, language = 'fr', onPaid }) {
    const [message, setMessage] = useState('');
    const { t } = useTranslation();
    const isInitialRender = useRef(true);

    function getLanguage(lang) {
        switch (lang) {
            case 'fr':
                return 'fr-FR';
            case 'en':
            default:
                return 'en-US';
        }
    }

    useEffect(() => {
        if (!formToken || !publicKey) return;

        // Pour chaque nouvelle commande, on peut rerender (Cart met un key sur StepPaymentCart si tu veux)
        if (isInitialRender.current) {
            isInitialRender.current = false;

            async function setupPaymentForm() {
                const endpoint = 'https://api.systempay.fr/';

                try {
                    const { KR } = await KRGlue.loadLibrary(endpoint, publicKey);

                    // Nettoyer d’anciens formulaires
                    await KR.removeForms();

                    await KR.setFormConfig({
                        formToken: formToken,
                        'kr-language': getLanguage(language)
                    });

                    await KR.renderElements('#myPaymentForm');

                    KR.onSubmit((response) => {
                        if (_.get(response, 'clientAnswer.orderStatus') === 'PAID') {
                            Helper.toast(t('responses.successPayment'), 'success');
                            if (onPaid) onPaid();
                        }
                    });
                } catch (error) {
                    setMessage(error + ' (see console for more details)');
                    console.error('Payment form setup error:', error);
                }
            }

            setupPaymentForm();
        }
    }, [formToken, publicKey, language, t, onPaid]);

    return (
        <div className="form">
            <div className="container">
                <div id="myPaymentForm" className="flex justify-center">
                    <div className="kr-smart-form" kr-card-form-expanded="false"></div>
                </div>
                <div data-test="payment-message">{message}</div>
            </div>
        </div>
    );
}